import { SET_TRIM_DATA } from '../actions/types';

export default function trimData(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_TRIM_DATA:
				return action.payload;
			// no default
		}
	}

	return state;
}
